import { useQuery } from '@tanstack/react-query';
import { schedulerMonitorApi } from '../api/schedulerMonitorApi';

/**
 * GET /scheduler-monitor/batch/jobs — 배치 작업 목록 (SCHEDULER_READ)
 * queryKey: ['scheduler-monitor', 'batch-jobs']
 */
export function useBatchJobs() {
  return useQuery({
    queryKey: ['scheduler-monitor', 'batch-jobs'],
    queryFn: () => schedulerMonitorApi.listBatchJobs(),
    staleTime: 60_000,
  });
}
